(function() {
  function initImages() {
    document.querySelectorAll('.media--transparent[style*="background-image"] img, .card__media[style*="background-image"] img, .thumbnail__image-wrapper[style*="background-image"] img').forEach(img => {
      const container = img.closest('[style*="background-image"]');
      if (!container) return;

      if (img.complete && img.naturalHeight > 0) {
        img.classList.add('loaded');
        container.classList.add('loaded');
      } else {
        img.addEventListener('load', () => {
          img.classList.add('loaded');
          container.classList.add('loaded');
        }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImages);
  } else {
    initImages();
  }

  new MutationObserver(() => initImages()).observe(document.body, { childList: true, subtree: true });
})();
